export default {
    eyebrow: 'Brand Brain',
    pill: {
        passed: '{passed} of {total} passed',
        failed: '1 to look at | {count} to look at',
        running: 'Running',
        waiting: 'Waiting for media',
        unavailable: 'Not run',
        loading: 'Loading',
    },
    reject: 'Reject',
    approve: 'Approve',
    approveAnyway: 'Bypass checks and approve',
    helper: 'Checks run against your Brand Brain: brand book, knowledge files and memories.',
    helperRerun: 'Something changed?',
    title: {
        passed: 'All Brand Brain checks have passed',
        failed: '1 Brand Brain check failed | {count} Brand Brain checks failed',
        unavailable: "Brand Brain checks didn't run",
        loading: 'Loading Brand Brain checks',
        running: "Brand Brain checks haven't finished yet",
        waiting: 'Waiting for a transcript or summary',
    },
    running: 'Checking against the brand book, knowledge files and memories.',
    waiting: 'Checks will run automatically when media processing provides text.',
    unavailableFallback: 'The Brand Brain checks could not run.',
    tally: {
        passed: '{count} successful',
        failed: '{count} failing',
        skipped: '{count} skipped',
        checks: 'check | checks',
    },
    skipped: 'Skipped',
    rerun: 'Run the checks again',
    confirm: {
        failed: 'Approve even though checks failed (bypass checks)',
        unavailable: 'Approve without Brand Brain checks (bypass checks)',
        running: 'Approve without waiting for Brand Brain checks (bypass checks)',
    },
}
